module.exports = __webpack_public_path__ + "static/media/02_05_01.fc2c8efe.png";